import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { auth as authActions } from '../actions';
import { auth, messaging, urls } from './../helpers';
import ClickableImageComponent from './../Components/ClickableImageComponent.jsx';

export const mapStateToProps = (state) => {
  const isAuthenticated = auth.checkAuthenticated(state);
  return {
    isActive: isAuthenticated,
    activeImageSource: urls.SETTINGS_AVAILABLE_SRC,
    disabledImageSource: urls.SETTINGS_UNAVAILABLE_SRC,
    activeHoverText: messaging.PROFILE_HOVERTEXT,
    disabledHoverText: messaging.ACCESS_SETTINGS_TEXT,
    height: 25,
    marginLeft: '-10px'
  };
};

export const mapDispatchToProps = (dispatch) => {
  const redirectFunc = () => push('/profile');
  return {
    onClick: () => {
      const action = auth.checkAuthenticated() ?
        push('/profile') :
        authActions.signInOrShowModal(redirectFunc);
      return dispatch(action);
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClickableImageComponent);


// WEBPACK FOOTER //
// src/Containers/ProfileButtonContainer.jsx